/**
 * Model labs whose display names start with M-R, in catalog order.
 *
 * Generated by `pnpm logos:sync`; see `../model-labs.ts`.
 */
export const LABS_M_R = [
    { id: 'magic', name: 'Magic', light: 'magic/magic-light.svg', dark: 'magic/magic-dark.svg' },
    { id: 'make', name: 'Make', light: 'make/make-light.svg', dark: 'make/make-dark.svg' },
    { id: 'manus', name: 'Manus', light: 'manus/manus-light.svg', dark: 'manus/manus-dark.svg' },
    {
        id: 'mastra',
        name: 'Mastra',
        light: 'mastra/mastra-light.svg',
        dark: 'mastra/mastra-dark.svg',
    },
    { id: 'mcp', name: 'MCP', light: 'mcp/mcp-light.svg', dark: 'mcp/mcp-dark.svg' },
    { id: 'mcpso', name: 'MCP.so', light: 'mcpso/mcpso-light.svg', dark: 'mcpso/mcpso-dark.svg' },
    { id: 'menlo', name: 'Menlo', light: 'menlo/menlo-light.svg', dark: 'menlo/menlo-dark.svg' },
    { id: 'meshy', name: 'Meshy', light: 'meshy/meshy-light.svg', dark: 'meshy/meshy-dark.svg' },
    { id: 'meta', name: 'Meta', light: 'meta/meta-light.svg', dark: 'meta/meta-dark.svg' },
    {
        id: 'metaai',
        name: 'Meta AI',
        light: 'metaai/metaai-light.svg',
        dark: 'metaai/metaai-dark.svg',
    },
    {
        id: 'metagpt',
        name: 'MetaGPT',
        light: 'metagpt/metagpt-light.svg',
        dark: 'metagpt/metagpt-dark.svg',
    },
    {
        id: 'microsoft',
        name: 'Microsoft',
        light: 'microsoft/microsoft-light.svg',
        dark: 'microsoft/microsoft-dark.svg',
    },
    {
        id: 'midjourney',
        name: 'Midjourney',
        light: 'midjourney/midjourney-light.svg',
        dark: 'midjourney/midjourney-dark.svg',
    },
    {
        id: 'minimax',
        name: 'MiniMax',
        light: 'minimax/minimax-light.svg',
        dark: 'minimax/minimax-dark.svg',
    },
    {
        id: 'mistral',
        name: 'Mistral AI',
        light: 'mistral/mistral-light.svg',
        dark: 'mistral/mistral-dark.svg',
    },
    {
        id: 'modelscope',
        name: 'ModelScope',
        light: 'modelscope/modelscope-light.svg',
        dark: 'modelscope/modelscope-dark.svg',
    },
    {
        id: 'monica',
        name: 'Monica',
        light: 'monica/monica-light.svg',
        dark: 'monica/monica-dark.svg',
    },
    {
        id: 'moonshot',
        name: 'Moonshot AI',
        light: 'moonshot/moonshot-light.svg',
        dark: 'moonshot/moonshot-dark.svg',
    },
    { id: 'morph', name: 'Morph', light: 'morph/morph-light.svg', dark: 'morph/morph-dark.svg' },
    { id: 'moxt', name: 'Moxt', light: 'moxt/moxt-light.svg', dark: 'moxt/moxt-dark.svg' },
    {
        id: 'myshell',
        name: 'MyShell',
        light: 'myshell/myshell-light.svg',
        dark: 'myshell/myshell-dark.svg',
    },
    { id: 'n8n', name: 'n8n', light: 'n8n/n8n-light.svg', dark: 'n8n/n8n-dark.svg' },
    {
        id: 'nanobanana',
        name: 'Nano Banana',
        light: 'nanobanana/nanobanana-light.svg',
        dark: 'nanobanana/nanobanana-dark.svg',
    },
    {
        id: 'nebius',
        name: 'Nebius',
        light: 'nebius/nebius-light.svg',
        dark: 'nebius/nebius-dark.svg',
    },
    {
        id: 'newapi',
        name: 'New API',
        light: 'newapi/newapi-light.svg',
        dark: 'newapi/newapi-dark.svg',
    },
    {
        id: 'notebooklm',
        name: 'NotebookLM',
        light: 'notebooklm/notebooklm-light.svg',
        dark: 'notebooklm/notebooklm-dark.svg',
    },
    {
        id: 'notion',
        name: 'Notion',
        light: 'notion/notion-light.svg',
        dark: 'notion/notion-dark.svg',
    },
    {
        id: 'nousresearch',
        name: 'Nous Research',
        light: 'nousresearch/nousresearch-light.svg',
        dark: 'nousresearch/nousresearch-dark.svg',
    },
    {
        id: 'novelai',
        name: 'NovelAI',
        light: 'novelai/novelai-light.svg',
        dark: 'novelai/novelai-dark.svg',
    },
    {
        id: 'novita',
        name: 'Novita AI',
        light: 'novita/novita-light.svg',
        dark: 'novita/novita-dark.svg',
    },
    {
        id: 'nplcloud',
        name: 'NPL Cloud',
        light: 'nplcloud/nplcloud-light.svg',
        dark: 'nplcloud/nplcloud-dark.svg',
    },
    {
        id: 'nvidia',
        name: 'NVIDIA',
        light: 'nvidia/nvidia-light.svg',
        dark: 'nvidia/nvidia-dark.svg',
    },
    {
        id: 'obsidian',
        name: 'Obsidian',
        light: 'obsidian/obsidian-light.svg',
        dark: 'obsidian/obsidian-dark.svg',
    },
    {
        id: 'ollama',
        name: 'Ollama',
        light: 'ollama/ollama-light.svg',
        dark: 'ollama/ollama-dark.svg',
    },
    {
        id: 'openwebui',
        name: 'Open WebUI',
        light: 'openwebui/openwebui-light.svg',
        dark: 'openwebui/openwebui-dark.svg',
    },
    {
        id: 'openai',
        name: 'OpenAI',
        light: 'openai/openai-light.svg',
        dark: 'openai/openai-dark.svg',
    },
    {
        id: 'openchat',
        name: 'OpenChat',
        light: 'openchat/openchat-light.svg',
        dark: 'openchat/openchat-dark.svg',
    },
    {
        id: 'openclaw',
        name: 'OpenClaw',
        light: 'openclaw/openclaw-light.svg',
        dark: 'openclaw/openclaw-dark.svg',
    },
    {
        id: 'opencode',
        name: 'OpenCode',
        light: 'opencode/opencode-light.svg',
        dark: 'opencode/opencode-dark.svg',
    },
    {
        id: 'openhands',
        name: 'OpenHands',
        light: 'openhands/openhands-light.svg',
        dark: 'openhands/openhands-dark.svg',
    },
    {
        id: 'openhuman',
        name: 'OpenHuman',
        light: 'openhuman/openhuman-light.svg',
        dark: 'openhuman/openhuman-dark.svg',
    },
    {
        id: 'openrouter',
        name: 'OpenRouter',
        light: 'openrouter/openrouter-light.svg',
        dark: 'openrouter/openrouter-dark.svg',
    },
    { id: 'palm', name: 'PaLM', light: 'palm/palm-light.svg', dark: 'palm/palm-dark.svg' },
    {
        id: 'parasail',
        name: 'Parasail',
        light: 'parasail/parasail-light.svg',
        dark: 'parasail/parasail-dark.svg',
    },
    {
        id: 'perplexity',
        name: 'Perplexity',
        light: 'perplexity/perplexity-light.svg',
        dark: 'perplexity/perplexity-dark.svg',
    },
    {
        id: 'phidata',
        name: 'Phidata',
        light: 'phidata/phidata-light.svg',
        dark: 'phidata/phidata-dark.svg',
    },
    { id: 'phind', name: 'Phind', light: 'phind/phind-light.svg', dark: 'phind/phind-dark.svg' },
    { id: 'pi', name: 'Pi', light: 'pi/pi-light.svg', dark: 'pi/pi-dark.svg' },
    { id: 'pika', name: 'Pika', light: 'pika/pika-light.svg', dark: 'pika/pika-dark.svg' },
    {
        id: 'pixverse',
        name: 'PixVerse',
        light: 'pixverse/pixverse-light.svg',
        dark: 'pixverse/pixverse-dark.svg',
    },
    {
        id: 'player2',
        name: 'Player2',
        light: 'player2/player2-light.svg',
        dark: 'player2/player2-dark.svg',
    },
    { id: 'poe', name: 'Poe', light: 'poe/poe-light.svg', dark: 'poe/poe-dark.svg' },
    {
        id: 'pollinations',
        name: 'Pollinations',
        light: 'pollinations/pollinations-light.svg',
        dark: 'pollinations/pollinations-dark.svg',
    },
    {
        id: 'poolside',
        name: 'Poolside',
        light: 'poolside/poolside-light.svg',
        dark: 'poolside/poolside-dark.svg',
    },
    { id: 'ppio', name: 'PPIO', light: 'ppio/ppio-light.svg', dark: 'ppio/ppio-dark.svg' },
    {
        id: 'prunaai',
        name: 'Pruna AI',
        light: 'prunaai/prunaai-light.svg',
        dark: 'prunaai/prunaai-dark.svg',
    },
    {
        id: 'pydanticai',
        name: 'Pydantic AI',
        light: 'pydanticai/pydanticai-light.svg',
        dark: 'pydanticai/pydanticai-dark.svg',
    },
    {
        id: 'qingyan',
        name: 'Qingyan',
        light: 'qingyan/qingyan-light.svg',
        dark: 'qingyan/qingyan-dark.svg',
    },
    { id: 'qiniu', name: 'Qiniu', light: 'qiniu/qiniu-light.svg', dark: 'qiniu/qiniu-dark.svg' },
    { id: 'qoder', name: 'Qoder', light: 'qoder/qoder-light.svg', dark: 'qoder/qoder-dark.svg' },
    { id: 'qwen', name: 'Qwen', light: 'qwen/qwen-light.svg', dark: 'qwen/qwen-dark.svg' },
    {
        id: 'railway',
        name: 'Railway',
        light: 'railway/railway-light.svg',
        dark: 'railway/railway-dark.svg',
    },
    {
        id: 'recraft',
        name: 'Recraft',
        light: 'recraft/recraft-light.svg',
        dark: 'recraft/recraft-dark.svg',
    },
    {
        id: 'relace',
        name: 'Relace',
        light: 'relace/relace-light.svg',
        dark: 'relace/relace-dark.svg',
    },
    {
        id: 'replicate',
        name: 'Replicate',
        light: 'replicate/replicate-light.svg',
        dark: 'replicate/replicate-dark.svg',
    },
    {
        id: 'replit',
        name: 'Replit',
        light: 'replit/replit-light.svg',
        dark: 'replit/replit-dark.svg',
    },
    { id: 'reve', name: 'Reve', light: 'reve/reve-light.svg', dark: 'reve/reve-dark.svg' },
    {
        id: 'roocode',
        name: 'Roo Code',
        light: 'roocode/roocode-light.svg',
        dark: 'roocode/roocode-dark.svg',
    },
    {
        id: 'rsshub',
        name: 'RSSHub',
        light: 'rsshub/rsshub-light.svg',
        dark: 'rsshub/rsshub-dark.svg',
    },
    {
        id: 'runway',
        name: 'Runway',
        light: 'runway/runway-light.svg',
        dark: 'runway/runway-dark.svg',
    },
    { id: 'rwkv', name: 'RWKV', light: 'rwkv/rwkv-light.svg', dark: 'rwkv/rwkv-dark.svg' },
];
//# sourceMappingURL=labs-m-r.js.map